import styled from "styled-components";

export const MyButton = styled.button`
  background-color: transparent;
  width: 5rem;
  height: 2rem;
  border: 1px solid white;
  color: white;
  cursor: pointer;
  :hover{
    background-color: white;
    color: black;
  }
`;